/**
 * Builds a service to access FeatureFlags
 * this is a copy of workspace eventService
 */

const subscribers = {};

export function getSubscribers(eventName) {
  const subscribersByEvent = [];
  subscribers[eventName].forEach((subscription) => subscribersByEvent.push(subscription.callback));
  return subscribersByEvent;
}

export function publishEvent(eventName, payload, metadata = {}) {
  if (!subscribers[eventName]) return;
  subscribers[eventName].forEach((subscription) => subscription.callback(payload, metadata));
}

export function subscribeToEvent(eventName, callback, coursewareId) {
  const subscription = { coursewareId, callback };
  if (!subscribers[eventName]) {
    subscribers[eventName] = [];
  }
  subscribers[eventName].push(subscription);
  // unsubscribe event
  return () => {
    subscribers[eventName] = subscribers[eventName].filter((subscriber) => subscriber.coursewareId !== coursewareId);
  };
}

export function unsubscribeEventByCoursewareId(coursewareId) {
  Object.keys(subscribers).forEach((eventName) => {
    subscribers[eventName] = subscribers[eventName].filter((subscription) => subscription.coursewareId !== coursewareId);
  });
}
